import { useMutation, useQuery } from '@apollo/client'
import { addDays } from 'date-fns';
import dateFormat from 'functions/dateFormat';
import { POST_REGISTER_FORM } from 'queries/registerQueries';
import { CREATE_USER, PAGINATE_USERS, UPDATE_USER } from 'queries/userQueries';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userCreator } from 'state/index';
import bcrypt from "bcryptjs";

const useSubmitRegisterForm = ({ onSuccess, onError }: any) => {
    const date = dateFormat(addDays(new Date(), 200), "yyyy-MM-dd");
    const hashString = `${date}${process.env.REACT_APP_ENV}HAPVIDA_FLOWS`

    const token = bcrypt.hashSync(hashString, 10);

    return useMutation(POST_REGISTER_FORM, {
        context: {
            headers: {
                token: token,
            }
        },
        onCompleted: (data) => {
            if(onSuccess) onSuccess(data);
        },
        onError: (error) => {
            if(onError) onError(error);
        }
    })
}

export {
    useSubmitRegisterForm,
}